import focus from './focus';

function install(Vue) {
  Vue.directive('focus', focus);
}

// eslint-disable-next-line import/prefer-default-export
export { install };
